export const Marquee = ({ items }) => {
  const doubled = [...items, ...items, ...items, ...items];
  return (
    <div data-testid="marquee" className="border-b border-ops bg-ops-core/20 py-3.5 overflow-hidden">
      <div className="marquee-track gap-12 text-[11px] uppercase tracking-[0.25em] mono-tag text-ops-muted">
        {doubled.map((item, i) => (
          <span key={i} className="whitespace-nowrap flex items-center gap-12">
            {item}
            <span className="text-ops-light">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
